import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "modal-new-invite",
  class: "modal fade",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "modal-new-invite-title",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-danger",
  role: "alert"
}
const _hoisted_8 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BtnSubmit = _resolveComponent("BtnSubmit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "modal-content",
        onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.applyShortcut && _ctx.applyShortcut(...args)))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[6] || (_cache[6] = _createElementVNode("h5", {
            class: "modal-title",
            id: "modal-new-invite-title"
          }, "Invite New Member", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { for: "modal-new-invite-name" }, "Name", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "modal-new-invite-name",
                placeholder: "How shall we call them?",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inviteName) = $event))
              }, null, 512), [
                [_vModelText, _ctx.inviteName]
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("small", { class: "form-text text-muted" }, "We will use this name to build an email text.", -1))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { for: "modal-new-invite-email" }, "Email", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "modal-new-invite-email",
                placeholder: "Valid email",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inviteEmail) = $event)),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.errorMessage = ''))
              }, null, 544), [
                [_vModelText, _ctx.inviteEmail]
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("small", { class: "form-text text-muted" }, [
                _createTextVNode("Read our "),
                _createElementVNode("a", {
                  href: "/about/tos",
                  target: "_blank"
                }, "ToS"),
                _createTextVNode(" and "),
                _createElementVNode("a", {
                  href: "/about/privacy",
                  target: "_blank"
                }, "Privacy policy"),
                _createTextVNode(". TL;DR: neither we nor you abuse the email service.")
              ], -1))
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_BtnSubmit, {
            title: "Send Invitation",
            spinner: "",
            ref: "submitButton",
            submitHandler: _ctx.invite
          }, null, 8, ["submitHandler"])
        ])
      ], 32)
    ])
  ]))
}